import styled from 'styled-components';
import IconCheckRoundFill from 'assets/Icons/Check/IconCheckRoundFill';
import { OpacityColor, PrimaryColor } from 'styles/Global/colorSemantic';
import { Body1Bold } from 'styles/Global/typography';
import DescriptionContainer from './DescriptionContainer';

export default function RecommandCard({ keyword, description, padding }: { keyword: string; description: string; padding?: string }) {
    return (
        <Card>
            <TextWrapper>
                <IconCheckRoundFill $width={24} $height={24} /> {/* 체크 아이콘 */}
                <Body1Bold $color={PrimaryColor.color_primary_normal}>{keyword}</Body1Bold>
            </TextWrapper>
            <DescriptionContainer description={description} padding='0px 2px' />
        </Card>
    );
}

const Card = styled.div<{ padding?: string }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    background: white;
    border-radius: 8px;
    border: 1px solid ${OpacityColor.color_opacity_primary_light_8};
    padding: ${(props) => props.padding ?? '16px'};
`;

const Description = styled.div`
    margin: 4px 0 0;
    color: #222;
    font-size: 15px;
    line-height: 1.5;
`;

const TextWrapper = styled.div`
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: center;
`;
